import { environment } from "../../../environments/environment";

export const SV_URL_AST = environment.services_ast;
export const SV_URL = environment.services;
export const SV_URL_SOCKET = environment.servicesSocket;
